import { GetTypeEnum } from '@app/app.enum';
import { CanadianFrenchlocale } from '@app/constants/core.constants';
import environment from '@app/environments/environment';
import * as models from '@app/models/index';
import axios, { AxiosResponse, CancelToken } from 'axios';
import { Injectable } from 'injection-js';
import * as queryString from 'query-string';

@Injectable()
export class AdminShipmentService {
	private baseUrl = environment.apiGateway.apiUrl;
	private apiUrl = '';
	private shipmentManifestApiUrl = '';
	private shipmentRetryApiUrl = '';

	constructor() {
		this.apiUrl = this.baseUrl + 'AdminShipment/';
		this.shipmentManifestApiUrl = this.baseUrl + 'AdminShipment/ShipmentManifestReport';
		this.shipmentRetryApiUrl = this.baseUrl + 'AdminShipment/ReattemptManifest';
	}

	/**
	 *   Get all shpment for Admin.
	 */
	public async GetAdminShipmentData(
		pageToken?: string,
		startDate?: Date,
		endDate?: Date,
		selectedCarrierSCACFilterValues?: string[],
		selectedCarrierCodeFilterValues?: string[],
		selectedCarrierProviderFilterValues?: string[],
		selectedPartnerFilterValues?: string[],
		customerVisibleAccountNumber?: string,
		trackingNumber?: string,
		selectedShipmentManifestStatusFilterValues?: string[],
		selectedShipmentRatingFilterValues?: string[],
		cancelToken?: CancelToken
	): Promise<models.IPagedResult<models.IShipment>> {
		try {
			const res = await axios.get<models.IPagedResult<models.IShipment>>(this.apiUrl, {
				cancelToken,
				params: {
					pageToken,
					startDate: startDate.toLocaleDateString(CanadianFrenchlocale),
					endDate: endDate.toLocaleDateString(CanadianFrenchlocale),
					carrierScac: selectedCarrierSCACFilterValues,
					carrierCode: selectedCarrierCodeFilterValues,
					carrierProvider: selectedCarrierProviderFilterValues,
					partnerVisibleAccount: selectedPartnerFilterValues,
					customerVisibleAccount: customerVisibleAccountNumber,
					shipmentManifestStatus: selectedShipmentManifestStatusFilterValues,
					shipmentRatingType: selectedShipmentRatingFilterValues,
					trackingNumber,
				},
				paramsSerializer: (params) => queryString.stringify(params),
			});
			return res.data;
		} catch (error) {
			throw error;
		}
	}

	/**
	 *  Update retry status for the shipment
	 */
	public async SetupRetry(shipmentId: string, cancelToken?: CancelToken): Promise<any> {
		const res = await axios.put<string>(this.shipmentRetryApiUrl + '/' + shipmentId, null, {
			cancelToken,
		});
		return res.data;
	}

	/**
	 *   Get all shipment manifests for Admin.
	 */
	public async GetShipmentManifestData(
		pageToken?: string,
		startDate?: Date,
		endDate?: Date,
		selectedManifestStatusFilterValues?: string[],
		trackingNumber?: string,
		cancelToken?: CancelToken
	): Promise<models.IPagedResult<models.IShipmentManifestReportVM>> {
		const res = await axios.get<models.IPagedResult<models.IShipmentManifestReportVM>>(this.shipmentManifestApiUrl, {
			cancelToken,
			params: {
				pageToken,
				startDate: startDate.toLocaleDateString(CanadianFrenchlocale),
				endDate: endDate.toLocaleDateString(CanadianFrenchlocale),
				manifestStatus: selectedManifestStatusFilterValues,
				trackingNumber,
			},
			paramsSerializer: (params) => queryString.stringify(params),
		});
		return res.data;
	}

	/**
	 *  Get all shipment details
	 */
	public async getShipmentForAdmin(
		key?: GetTypeEnum,
		value?: string,
		packageNumber?: number,
		accountId?: string,
		cancelToken?: CancelToken
	): Promise<models.IShipment> {
		const res = await axios.get<models.IShipment>(this.apiUrl + 'PackageNumber', {
			cancelToken,
			params: {
				key,
				value,
				packageNumber,
				accountId,
			},
		});
		return res.data;
	}

	/**
	 *  export Admin shipment data
	 */
	public async exportAdminShipmentData(
		startDate?: Date,
		endDate?: Date,
		selecteCarrierSCACFilterValues?: string[],
		selectedCarrierCodeFilterValues?: string[],
		selectedCarrierProviderFilterValues?: string[],
		selectedPartnerFilterValues?: string[],
		customerVisibleAccountNumber?: string,
		trackingNumber?: string,
		cancelToken?: CancelToken
	): Promise<AxiosResponse<Blob>> {
		try {
			const url = this.apiUrl + 'Export';
			const res = await axios.get<Blob>(url, {
				cancelToken,
				responseType: 'blob',
				params: {
					startDate: startDate.toLocaleDateString(CanadianFrenchlocale),
					endDate: endDate.toLocaleDateString(CanadianFrenchlocale),
					carrierScac: selecteCarrierSCACFilterValues,
					carrierCode: selectedCarrierCodeFilterValues,
					carrierProvider: selectedCarrierProviderFilterValues,
					partnerVisibleAccount: selectedPartnerFilterValues,
					customerVisibleAccount: customerVisibleAccountNumber,
					trackingNumber,
				},
				paramsSerializer: (params) => queryString.stringify(params),
			});
			return res;
		} catch (error) {
			throw error;
		}
	}

	/**
	 *   Get shipment filter for Admin.
	 */
	public async getAdminShipmentFilter(
		selecteCarrierSCACFilterValues?: string[],
		cancelToken?: CancelToken
	): Promise<models.IAdminShipmentFilters> {
		try {
			const res = await axios.get<models.IAdminShipmentFilters>(this.apiUrl + 'Filter', {
				cancelToken,
				params: {
					carrierScac: selecteCarrierSCACFilterValues,
				},
				paramsSerializer: (params) => queryString.stringify(params),
			});
			return res.data;
		} catch (error) {
			throw error;
		}
	}
}



// WEBPACK FOOTER //
// ./src/services/admin-shipment.service.ts